// removed by extract-text-webpack-plugin
module.exports = {"BodySize":"BodySize","BodySize__container":"BodySize__container","BodySize__box":"BodySize__box","BodySize__box-left":"BodySize__box-left","BodySize__box-right":"BodySize__box-right","BodySize__description":"BodySize__description","BodySize__description__text-pc":"BodySize__description__text-pc","BodySize__description__text-mb":"BodySize__description__text-mb","BodySize__image":"BodySize__image","BodySize__image__image-pc":"BodySize__image__image-pc","BodySize__image__image-mb":"BodySize__image__image-mb","BodySize__notice":"BodySize__notice","BodySize__body-type-model":"BodySize__body-type-model"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/body-size/styles.css
// module id = 838
// module chunks = 0 1